export default (array, i) => array && array.length > i && array[i];
